// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
} from "react-admin";
import { JsonField, JsonInput } from "react-admin-json-view";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const ProvincesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput label="Type" source="type" alwaysOn />
    <TextInput label="Region" source="region" alwaysOn />
    <BooleanInput label="Display" source="display" />
  </Filter>
);

export const ProvincesList = (props) => (
  <List
    {...props}
    filters={<ProvincesFilter />}
    pagination={<PostPagination />}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="type" />
      <TextField source="region" />
      <BooleanField source="display" />

      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const ProvincesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="type" />
      <TextField source="region" />
      <JsonField source="properties" />
      <BooleanField source="display" />
    </SimpleShowLayout>
  </Show>
);

export const ProvincesEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="type" />
      <TextInput source="region" />
      <JsonInput source="properties" />
      <BooleanInput source="display" />
    </SimpleForm>
  </Edit>
);
